﻿import {Children, JSX, ReactNode, useId, useMemo} from "react";

export default function PopOver({children}: { children: ReactNode | ReactNode[] }): JSX.Element {
	const id = useId();
	const [menuId, popoverId] = useMemo(() => {
		return [`menu_${id}`, `popover_${id}`]
	}, []);

	const wrappedChildren = Children.map(children, (child, index) => {
		return <li key={index}>{child}</li>;
	});

	return <>
		<button className="material-symbols-rounded popover-menu-button" id={menuId} popoverTarget={popoverId} type="button">more_vert</button>
		<div popover="auto" id={popoverId} anchor={menuId} className="popover-menu">
			<menu>{wrappedChildren}</menu>
		</div>
	</>;
};
